import { useEffect, useState } from 'react';
import { useGetApps } from './../services/useGetApps';
import { IconsByTag } from 'src/constants/hooks/iconsApps';

/**
 * @description Lista de apps que precisam de verificação de nome
 * @description A estrutura da lista é {key: value} onde key é o 'codigo' do app e value é o nome correto do app.
 * @example Bime Ai vem como AIBIME, precisa de tratamento para ser Bime IA.
 */
export const CHECK_NAME_APPS: Record<number, string> = {
    4: 'Analytics',           // codigo do Analytics Pro (tag: INTELVENDAS)
    5100: 'Bime IA',          // codigo do IA - Bime (tag: IA_BIME)
    5101: 'Waipe',            // codigo do IA - Waipe (tag: IA_WAIPE)
    6100: 'Waipe - Datalab',  // codigo do Datalab (tag: DATALAB_N1)
    5104: 'Unique IA',        // codigo do IAUNIQUE (tag: IA_UN)
}

export interface ObjAppsProps {
  tag: string;
  name: string;
  ativo: any;
  iconMarketApp: string | null;
}

export function useAppsCard() {
  const { dataApps } = useGetApps();
  const [objApps, setObjApps] = useState<ObjAppsProps[] | undefined>([]);
  const returnApps = () => {
    if (!dataApps) return;

    const objCard: ObjAppsProps[] = Object.values(dataApps).map((value) => {
      const codigoKey = Number(value?.codigo);
      const tagKey = value?.tag;

      return {
        tag: tagKey,
        name: CHECK_NAME_APPS[codigoKey] ?? value?.nome,
        ativo: value?.indAtivar === 'S',
        iconMarketApp: IconsByTag[tagKey]?.url ?? null,
      }
    });

    setObjApps(objCard);
  };

  useEffect(() => {
    returnApps();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataApps]);

  return { objApps };
}

